<!-- login.vue
    Permite el acceso o inicio de sesión (login) a la aplicación. -->
<!-- *:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:= -->
<template id="login">
    <div class="container">

        <!-- //* Muestra un mensaje de error si no se ingresa email y clave -->
        <p v-show="errorIngreso"
            class="brand-logo red center animated fadeIn" 
            transition="fade"
            style="font-size:18px;">
            <span style="color:white">
                Debe ingresar un e-mail y una clave !
            </span>
        </p>
        
        <!-- //? INGRESO CON CREDENCIALES WEB -->
        <div class="row">
            <div style="height:60px"></div>
            <div class="col s12 l3"></div>
            <div class="col s12 l6 white z-depth-5 animated zoomIn"
                    transition="zoomIn">

                <div style="height:20px"></div>

                <!--//? email autofocus  -->
                <!--//!  input-field inline -->
                <!--//!  <label for="email_inline">Correo electrónico ?</label>  -->
                <div class="col s12">
                    <i class="material-icons prefix">email</i>                        
                    <input id="email_inline" 
                        ref="email_inline"
                        type="email" 
                        v-model="email"
                        class="validate">
                    <label >Correo electrónico ?</label>
                    <span class="helper-text" 
                        data-error="No valido 😓" 
                        data-success="Correcto 😊"></span>
                </div>
                <!-- //? password -->
                <div class="col s12 l12">

                    <!--//? Si se oculta la clave, muestra asteriscos --> 
                    <div v-if="ocultarClave" 
                        class="col s12 l10">
                        <i class="material-icons prefix">vpn_key</i>                        
                        <input @blur="enfocar"
                            v-on:keyup.enter="signIn()"
                            id="password"
                            type="password"
                            v-model="password"
                            class='validate'>
                        <label >Clave de Acceso ?</label>
                    </div>
                    <!--//? de lo contrario, muestra la clave cuando se está escribiendo. -->
                    <div v-else 
                        class="col s12 l10">
                        <i class="material-icons prefix">vpn_key</i>                        
                        <input @blur="enfocar"
                            v-on:keyup.enter="signIn()"
                            id="password"
                            type="text"
                            v-model="password"
                            class="validate">
                        <label >Clave de Acceso ?</label>
                    </div>
                    <!--//? Botón/Icono para mostrar/ocultar la clave de acceso. -->
                    <div class="col s12 l1">
                        <div style="height:15px;"></div>                    
                        <a class="btn white tooltipped" 
                            :data-tooltip='ocultarClave ? "Mostrar Clave" : "Ocultar Clave"' data-position="bottom" 
                            @click="toogleClave">
                            <a style="color:black"> 
                                <i class="material-icons">
                                    {{ocultarClave ? 'visibility_off' : 'visibility'}}
                                </i>
                            </a>
                        </a>
                    </div>
                </div>

                <!--//? botón de aceptar -->
                <div class="col s12 center">                            
                    <button class="waves-effect waves-purple blue btn darken-2" 
                            @click="signIn"
                            id='idBoton'
                            ref="idBoton"> 
                            <a style="font-size:16px; color: white">
                                Ingresar</a>
                    </button> 
                </div> <!--//* botón aceptar -->

                <!--//? spinner para la espera de ingreso a sesión -->
                <div class="row">
                    <div class="col s5"></div>
                    <div class="col s2" v-if="mostrarCargador">
                        <div class="sk-fading-circle">
                            <div class="sk-circle1 sk-circle"></div>
                            <div class="sk-circle2 sk-circle"></div>
                            <div class="sk-circle3 sk-circle"></div>
                            <div class="sk-circle4 sk-circle"></div>
                            <div class="sk-circle5 sk-circle"></div>
                            <div class="sk-circle6 sk-circle"></div>
                            <div class="sk-circle7 sk-circle"></div>
                            <div class="sk-circle8 sk-circle"></div>
                            <div class="sk-circle9 sk-circle"></div>
                            <div class="sk-circle10 sk-circle"></div>
                            <div class="sk-circle11 sk-circle"></div>
                            <div class="sk-circle12 sk-circle"></div>
                        </div>
                    </div>                        
                    <div class="col s5"></div>
                </div> 
                <!--//* row -->
            </div>
            <div class="col s12 l3"></div>
        </div>
   
        <!-- <input type="text" class="datepicker"> -->
   
    </div> 
    <!--//* container -->
</template>

<!-- 
        background: url(/topevaluaciones/src/assets/imagenes/2.jpg);

        background: url(/src/assets/imagenes/2.jpg);
-->
<!-- <style>
    figure{
        background: url(/topevaluaciones/src/assets/imagenes/2.jpg);
        background-repeat: no-repeat;
        background-position: top right; 
        background-attachment:relative; 
    }
</style> -->

<!-- ============================================================================= 
                                <div class="loader center"></div>
-->
<script>

     import Vue from 'vue'

    import {store} from './../store/store.js'
    import firebase from 'firebase';

    import 'materialize-css/dist/css/materialize.min.css'
    import M from 'materialize-css'

//     import cabecera from './login_header.vue'

    /* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */    
    export default {

        name: 'login',
        data: function(){
            return { 
               email: null, password: null,
               ocultarClave: true, mostrarCargador: false,
               errorIngreso: false, //* Por default no hay error en el ingreso

            }
        },

        mounted(){

            var elems = document.querySelectorAll('.collapsible');
            var instances = M.Collapsible.init(elems, {});        
            
            this.enfocar();
        },        
        methods:{
          enfocar(){

               Vue.nextTick().then(()=> this.$refs.email_inline.focus());             
          },

            toogleClave(){
                this.ocultarClave= ! this.ocultarClave;
            },
            signInMem(){

                // console.log("Estoy en sigInMem !");
                store.state.st_logeado  = true;
                store.state.st_activo   = true;
                store.state.st_roles   = {};
                store.state.st_roles.encuesta= true;
                store.state.st_admin=   true;

                const self =    this;           // SELF es para usarlo dentro de las promesas en lugar de THIS                
                self.$router.push('/');         // Direcciona el ruteo al HOME.                
            },
            signIn(){

                const self =    this;           // SELF es para usarlo dentro de las promesas en lugar de THIS
                var elUID=      "";             // Preserva la llave del usuario autenticado.
                self.mostrarCargador = true;

                /* Verifica si el usuario y clave existen en Firebase */
                firebase.auth().signInWithEmailAndPassword(this.email, this.password)
                .then(function (user) {

                    self.mostrarCargador= false;
                    elUID       = user.user.uid;    // Otiene el UID del usuario autenticado
                    self.bdReadUsuarios(elUID);     // Lee el nodo del usuario para obtener su nombre completo.
                    self.$router.push('/');         // Direcciona el ruteo al HOME.
                })
                .then(function () {

                    self.laUID  = elUID;    // Obtiene la UID preservada.

                    /* Asigna en las variables globales (las definidas en el store) los valores para: 
                        i) saber si está logeado o no el usuario; ii) la UID del usuario, su email y 
                        su password. */
                    store.state.st_logeado = true;             
                    store.state.st_usuario = self.laUID;
                }) 
                .catch(function(error) {

                    self.mostrarCargador= false;

                    /* Obtiene el número y mensaje de error cuando la autenticación es incorrecta */
                    var errorCode = error.code;
                    var errorMessage = error.message;

                    var miMensaje = "NO ERROR";     // Asume que no hay mensaje de error.

                    if (errorCode === "auth/user-not-found"){
                        miMensaje = "Email Invalido. Cuenta NO existe !"
                    } else {
                        if (errorCode === "auth/wrong-password"){
                            miMensaje = "Password Invalido. El password NO existe o No escribió Password !"
                        } else {
                            if (errorCode === "auth/invalid-email") {
                                miMensaje= "Email Invalido. La cuenta de email tiene un formato NO válido."
                            } else{
                                if (errorCode === "auth/operation-not-allowed"){
                                    miMensaje= "El proveedor de inicio de sesión dado está deshabilitado para este proyecto de Firebase.\n"+
                                                "Habilítelo en la consola de Firebase, debajo del inicio de sesión: "+
                                                "pestaña de método de la sección de autenticación.";
                                } // if
                            } // else
                        } // else
                    } // else

                    /* Si Encontró algún error lo muestra !*/
                    if (miMensaje != "NO ERROR"){
                        alert(miMensaje);
                    }
                }); // catch()
            }, // signIn()
            getUsuarios(losUsuarios,laLlave){

                /* Recorro la info original del nodo para encontrar el nombre del usuario */
                /* Prepara el objeto de memoria para obtener la lista de usuarios */
                // store.state.usuarios= [];
                for (let key in losUsuarios){

                    // console.log("key ? ",key,"; id ? ",", usuario ? ",losUsuarios[key].nombre);
                    /* Si la ID del usuario en sesión fue encontrada, entonces obtiene el nombre del usuario, 
                       los roles que tiene asignados y si está o no activo */
                    if (losUsuarios[key].laid === laLlave){

                        store.state.st_nusuario= losUsuarios[key].nombre;
                        store.state.st_roles=    losUsuarios[key].roles;
                        store.state.st_activo=   losUsuarios[key].activo;
                        store.state.st_admin=    losUsuarios[key].administrador;
                        store.state.st_email=    losUsuarios[key].email;
                        store.state.st_clave=    losUsuarios[key].clave;
                        store.state.st_empresa=  losUsuarios[key].empresa;
                        store.state.st_sexo  =    losUsuarios[key].sexo;
                        store.state.st_depto=     losUsuarios[key].depto;
                        store.state.st_empezo=     losUsuarios[key].empezo;

                        store.state.st_llave=    key;
                    }; // if()
                } // for      
               // console.log("roles ? ",store.state.st_roles.ev02_perfil);
               store.state.evalua= (store.state.st_roles.ev01_tipolo || store.state.st_roles.ev02_perfil || 
                                        store.state.st_roles.ev02_perfil || store.state.st_roles.ev03_16pf || 
                                        store.state.st_roles.ev04_npf || store.state.st_roles.ev05_cpf || 
                                        store.state.st_roles.ev06_moss || store.state.st_roles.ev07_tav || 
                                        store.state.st_roles.ev08_solemp || store.state.st_roles.ev09_emocio || 
                                        store.state.st_roles.ev10_auxili || store.state.st_roles.ev11_vtas ||
                                        store.state.st_roles.ev12_aedp
                                        );
               console.log("evaluaciones ? ",store.state.evalua);
               console.log("roles ? ",store.state.st_roles);

            }, // getUsuarios
            bdReadUsuarios(laLlave){

                var dummy= store.state.st_dbUsuarios
                            .on( 'value',snapshot=> this.getUsuarios( snapshot.val(), laLlave ) );
            }, // bdReadUsuarios
        }, // methods
    } // export

</script>


// WEBPACK FOOTER //
// src/components/login.vue